import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import logo from "../../assets/img/illustrations/falcon.png";
interface PropsType {
	at?: "navbar-vertical" | "navbar-top" | "auth";
	width?: number;
	className?: string;
	textClass?: string;
}
const Logo: React.FC<PropsType> = ({
	at,
	width,
	className,
	textClass,
	...rest
}) => {
	return (
		<Link
			to="/"
			className={classNames(
				"text-decoration-none",
				{ "navbar-brand text-left": at === "navbar-vertical" },
				{ "navbar-brand text-left": at === "navbar-top" },
			)}
			{...rest}>
			<div
				className={classNames(
					"d-flex",
					{
						"align-items-center py-3": at === "navbar-vertical",
						"align-items-center": at === "navbar-top",
						"flex-center fw-bolder fs-5 mb-4": at === "auth",
					},
					className,
				)}>
				<span className={""}>
					<img className="me-2" src={logo} alt="Logo" width={width} />
				</span>
			</div>
		</Link>
	);
};

export default Logo;
